/**
 * ProfileList Component
 * Lista spremljenih feed profila (dobavljača)
 */

import {
  Card,
  CardContent,
  Typography,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Button,
  Divider,
} from '@mui/material';
import {
  Storage as DatabaseIcon,
  Add as AddIcon,
} from '@mui/icons-material';
import { FeedProfile } from '../types';

interface ProfileListProps {
  profiles: FeedProfile[];
  selectedProfile: FeedProfile | null;
  onSelectProfile: (profile: FeedProfile) => void;
  onNewProfile: () => void;
  children?: React.ReactNode; // Za SupplierPriority i UpdateFieldsPanel
}

export function ProfileList({
  profiles,
  selectedProfile,
  onSelectProfile,
  onNewProfile,
  children,
}: ProfileListProps) {
  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Spremljeni profili
        </Typography>

        <List dense>
          {profiles.length === 0 ? (
            <Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>
              Nema spremljenih profila
            </Typography>
          ) : (
            profiles.map(profile => (
              <ListItemButton
                key={profile.id}
                selected={selectedProfile?.id === profile.id}
                onClick={() => onSelectProfile(profile)}
              >
                <ListItemIcon>
                  <DatabaseIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText
                  primary={profile.name}
                  secondary={
                    profile.last_import
                      ? `Zadnji: ${new Date(profile.last_import).toLocaleDateString()}`
                      : 'Nikad'
                  }
                />
              </ListItemButton>
            ))
          )}
        </List>

        <Divider sx={{ my: 1 }} />

        <Button
          fullWidth
          startIcon={<AddIcon />}
          onClick={onNewProfile}
        >
          Novi profil
        </Button>

        {/* Additional panels (SupplierPriority, UpdateFields) */}
        {children}
      </CardContent>
    </Card>
  );
}
